<!-- =========================================================================================
    File Name:
    Description:
    ----------------------------------------------------------------------------------------
    Item Name: GetBoarded UI Template
    Author: GetBoarded
    Author URL: https://www.getboarded.com
========================================================================================== -->

<template>
  <footer class="the-footer flex-wrap justify-between" :class="classes">
    <p>
      <span>&copy;</span>
      <span>{{ new Date().getFullYear() }} </span>
      <a :href="url" target="_blank" rel="nofollow">Coach</a>
      <span class="sm:inline-block">, All rights Reserved</span>
<!--      <span>&nbsp;|&nbsp;</span>-->
<!--      <changeLog class="inline" style="color:rgba(var(&#45;&#45;vs-primary),1)" headText="Changelog" />-->
    </p>
    <!--<span class="md:flex hidden items-center">
      <span>Hand-crafted & Made with</span>
      <feather-icon
        icon="HeartIcon"
        svgClasses="stroke-current text-danger w-6 h-6"
        class="ml-2"
      />
    </span>-->
  </footer>
</template>

<script>
import constants from "../../constants";
import changeLog from '../../views/changelog.vue'
export default {
  name: "the-footer",
  data () {
    return {
      url: constants.url
    };
  },
  components: {
    changeLog
  },
  props: {
    classes: {
      type: String
    }
  }
};
</script>
